<!-- src/components/Toast.vue -->
<template>
  <div
    class="toast-container"
    v-for="(notification, i) in notifications"
    :key="notification.idx"
    :style="{ top: `${16 + i * 28}px` }"
    @click="oth_showAlarmList(true)"
  >
    <img src="/imgs/LOGO.png" />
    <div>
      <h2>{{ notification.title }}</h2>
      <span>{{ notification.message }}</span>
    </div>
  </div>
</template>


<script>
import { ref, inject } from "vue";

export default {
  props: {
    oth_showAlarmList: {
      type: Function,
      default: () => {},
    },
  },
  setup() {
    const member_info = inject('member_info');
    const sql_query = inject('sql_query');
    const notifications = ref([]);

    const maxNotificationCount = 2;

    async function fetchNotifications() {
      const res = await sql_query(
        `SELECT * FROM notifications WHERE mb_id = '${member_info.mb_id}' AND is_read = 0 ORDER BY idx DESC`
      );

      if (!res || !res.length) return;

      notifications.value = [];

      // 1) 실제 알림 먼저 (최대 maxNotificationCount개)
      res.slice(0, maxNotificationCount).forEach((n, i) => {
        setTimeout(() => notifications.value.push(n), i * 300);
      });

      // 2) 초과 알림이 있을 때 마지막에 표시
      if (res.length > maxNotificationCount) {
        setTimeout(() => {
          notifications.value.push({
            idx: 'more',
            title: `그 외 ${res.length - maxNotificationCount}개의 알림`,
            message: '',
          });
        }, maxNotificationCount * 300);
      }

      // 3) 표시한 알림을 읽음 처리 (다시 안 뜨게)
      const idxList = res.map(n => n.idx).join(',');
      await sql_query(
        `UPDATE notifications SET is_read = 1 WHERE idx IN (${idxList})`
      );
    }

    fetchNotifications();
    return { notifications };
  },
};
</script>



<style scoped>
.toast-container {
  min-width: 200px;
  min-height: 52px;
  width:fit-content;
  height: 52px;
  padding: 0px 16px;
  position: fixed;
  top: 16px; right: 50%;
  transform: translateX(50%);
  display: flex;
  gap: 12px;
  background: var(--color-surface-deep);
  backdrop-filter: blur(6px);
  border-radius: 12px;
  z-index: 9999;
  animation: fadeInOut 3s forwards;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display:flex;
  align-items:center;
  justify-content: center;
  cursor:pointer;
}

.toast-container img {
  width: 24px;
  height: 24px;
  object-fit: cover;
}

.toast-container > div {
  display: flex;
  flex-direction: column;
}

.toast-container > div h2 {
  font-size: 16px;
  font-weight: 600;
  padding:0;
  margin:0;
}

.toast-container > div span {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text-primary);
  line-height: 1.4;
}

@keyframes fadeInOut {
  0% { opacity: 0; transform: translateY(-24px) translateX(50%); }
  10% { opacity: 1; transform: translateY(6px) translateX(50%); }
  30% { opacity: 1; transform: translateY(0) translateX(50%); }
  80% { opacity: 1; transform: translateY(0) translateX(50%); }
  95% { opacity: 1; transform: translateY(6px) translateX(50%); }
  100% { opacity: 0; transform: translateY(-24px) translateX(50%); }
}
</style>
